import React from 'react'
import ListingPage, { TABLE_ACTIONS } from '../../../containers/ListingPage'
import { Row, Cell } from '../../../components/Table'
import { DropDown, DropDownItem, ICONS } from '../../../components/DropDown'

import RoleForm from './Form'
import RolesFilter from './Filters'

import { getMessage } from '../../../lib/translator'

import EmptyIcon from '../UserShifts/employeeEmpty.svg'
import './style.css'

export const EmptyState = {
  icon: EmptyIcon,
  message: getMessage('role.empty.message'),
  actions: ({ onAction }) => (
    <button
      className="primary button"
      onClick={() => {
        onAction(TABLE_ACTIONS.ADD)
      }}
    >
      + {getMessage('role.add')}
    </button>
  ),
}

// The legacy role handler returns different shapes per verb: list → {role:[...]},
// update → a bare Detail {id,name,endpoints}, create → a plain string. ListingPage
// reuses this transform for all of them, so be shape-agnostic: return the array for
// the list, the object (with id) for update so the row splices instead of crashing,
// and undefined for the create string (skip the optimistic add).
export const transformRolesResponse = (response) => {
  const data = response && response.data
  if (data && Array.isArray(data.role)) {
    return data.role
  }
  if (data && typeof data === 'object') {
    return data
  }
  return undefined
}

// The form manages the endpoint picker + per-endpoint method state; flatten to the
// backend payload { name, endpoints:[{id, method:[]}] }. organizationId is injected
// by the gateway (set-context), matching every other account-service write form.
export const transformRoleSubmit = (formData) => {
  const selected = formData.endpoints || []
  const methods = formData.methods || {}
  return {
    name: formData.name,
    endpoints: selected.map((ep) => ({
      id: ep.id,
      method: methods[ep.id] || [],
    })),
  }
}

export const transformRoleFilterSubmit = (formData) => {
  const modifiedData = Object.assign({}, formData)
  if (modifiedData.name) {
    modifiedData.name = modifiedData.name.name
  }
  return modifiedData
}

export const TableProperties = {
  headers: [getMessage('role.name'), getMessage('role.action')],
  row: ({ id, name, editable, onAction }) => (
    <Row>
      <Cell>
        <span
          className="role-name"
          onClick={() => onAction(TABLE_ACTIONS.EDIT, { id })}
        >
          {name.toLowerCase()}
        </span>
      </Cell>
      <Cell>
        {editable && (
          <DropDown icon={<img src={ICONS.VELLIP} alt="⋮" />}>
            <DropDownItem onClick={() => onAction(TABLE_ACTIONS.EDIT, { id })}>
              {getMessage('role.edit')}
            </DropDownItem>
            <DropDownItem
              onClick={() => onAction(TABLE_ACTIONS.DELETE, { id })}
            >
              {getMessage('role.delete')}
            </DropDownItem>
          </DropDown>
        )}
      </Cell>
    </Row>
  ),
}

// Rendered inside the Roles/Endpoints tab wrapper WITHOUT a `menu` prop (bare WithoutMenuPage).
export default class RolesTab extends React.Component {
  render() {
    return (
      <ListingPage
        className="roles-page"
        addHeading={getMessage('role.add.heading')}
        editHeading={getMessage('role.edit.heading')}
        api={{
          url: '/account-service/role',
          transform: transformRolesResponse,
        }}
        tableProperties={TableProperties}
        emptyState={EmptyState}
        headerActions={({ onAction }) => (
          <button
            className="primary button"
            onClick={() => {
              onAction(TABLE_ACTIONS.ADD)
            }}
          >{`+ ${getMessage('role.add')}`}</button>
        )}
        form={{
          component: RoleForm,
          transformSubmit: transformRoleSubmit,
        }}
        filters={{
          component: RolesFilter,
          transformSubmit: transformRoleFilterSubmit,
        }}
      />
    )
  }
}
